import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import BaseHttpService from '@hp-core/services/base-http.service';
import { catchError, map, Observable, of, throwError } from 'rxjs';
import { IAuthority, IPostLoginResponse } from '../_types/auth.interface';
import { TranslateService } from '@ngx-translate/core';
import { UserStoreService } from '@hp-core/services/user-store.service';
import { LoginProcessAdapter } from '../_adapters/login-process.adapter';
import { Router } from '@angular/router';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthService extends BaseHttpService {
  private readonly translate = inject(TranslateService);
  constructor(
    private _httpClient: HttpClient,
    private _userStore: UserStoreService,
    private router: Router
  ) {
    super();
  }

  private _httpPostLogin(username: string, password: string) {
    return this._httpClient.post<IPostLoginResponse>(
      this.getUri({}, 'auth', 'login'),
      { username, password }
    );
  }

  public loginProcess(
    username: string,
    password: string
  ): Observable<{ logged: boolean; message: any }> {
    return this._httpPostLogin(username, password).pipe(
      switchMap((response) => this._userStore.updateUser(response)),
      map((response) => {
        if (!response.user.enabled) {
          console.log('account.user.enabled');
          throw new Error(this.translate.instant('auth.errors.not_enabled'));
        }

        if (
          this.hasEnabledPlatformEntrance(
            this.mapRoles(response.user.authorities)
          )
        ) {
          return {
            logged: true,
            message: this.translate.instant('auth.success'),
          };
        } else {
          throw new Error(this.translate.instant('auth.errors.not_permited'));
        }
      }),
      catchError((error: unknown) => {
        if (error instanceof HttpErrorResponse) {
          console.error(error);
          console.error(`HTTP Error: ${error.message}`);
          return throwError(
            () => new LoginProcessAdapter(false, error.error.mensaje ?? '')
          );
        }
        if (error instanceof Error) {
          return throwError(
            () => new LoginProcessAdapter(false, error.message)
          );
        }
        console.error(`Unknown Error: ${error ?? 'unknown'}`);
        return throwError(() => new LoginProcessAdapter(false, error + ''));
      })
    );
  }

  public forgotPaswordProcess(email: string) {
    // TODO:Implement
    return of({ code: 2749981 });
  }

  public validatePasswordResetCode(code: number) {
    // TODO:Implement
    if (code === 2749981) {
      return of(true);
    } else {
      return of(false);
    }
  }

  public resetPasswordProcess(code: number, password: string) {
    // TODO:Implement
    return of(true);
  }

  public logOff() {
    this._userStore.cleanData();
    this.router.navigate(['auth', 'login']);
  }

  protected hasEnabledPlatformEntrance(roles: string[]): boolean {
    return roles.some(
      (item) => item.includes('CLIENT') || item.includes('ADMIN')
    );
  }

  protected mapRoles(roles: IAuthority[]) {
    return roles.map((item) => item.authority);
  }
}
